import { Component, Input } from "@angular/core";
import { Platform } from "@ionic/angular";
import { ConfigService } from "src/app/services/config/config.service";
import { InAppBrowser } from "@awesome-cordova-plugins/in-app-browser/ngx";
import { Navigator } from "src/app/components/menu/navigator";

@Component({
  selector: "app-update",
  templateUrl: "./app-update.component.html",
  styleUrls: ["./app-update.component.scss"],
})
export class AppUpdateComponent {
  public iOS: boolean = false;
  private unregisterBackButtonAction: any;
  @Input() appversion: any = "not available";
  @Input() appURL: any;
  @Input() appMessage: any = "An app update is available";
  @Input() btnLabel: any = "UPDATE";

  constructor(
    protected platform: Platform,
    public config: ConfigService,
    public navigator: Navigator,
    private iab: InAppBrowser
  ) {
    this.initializeBackButtonCustomHandler();
    if (this.platform.is("ios")) {
      this.iOS = true;
    }
  }

  ionViewWillLeave() {
    this.unregisterBackButtonAction && this.unregisterBackButtonAction();
  }

  initializeBackButtonCustomHandler() {
    // old this.unregisterBackButtonAction = this.platform.registerBackButtonAction(function(event){
    this.platform.backButton.subscribeWithPriority(101, (event) => {
      console.log("Prevent Back Button Page Change... You Stuck!");

      this.navigator.navigateTo(
        "AppUpdateComponent",
        {},
        {
          appversion: this.appversion,
          appURL: this.appURL,
          appMessage: this.appMessage,
          btnLabel: this.btnLabel,
        }
      );
    }); // Priority 101 will override back button handling (we set in app.component.ts) as it is bigger then priority 100 configured in app.component.ts file */
  }

  onAppUpdate() {
    let updateURL = "";
    if (this.platform.is("android")) {
      updateURL = this.config.getConfig().APP_UPDATE_URL_ANDROID;
      console.log("updateURLAnd", updateURL);
      window.open(updateURL, "_system");
    }
    if (this.platform.is("ios")) {
      updateURL = this.config.getConfig().APP_UPDATE_URL_IOS;
      console.log("updateURLIOS", updateURL);
      this.iab.create(
        updateURL,
        "_system",
        "location=no,enableviewportscale=yes"
      );
    }
  }
}
